import a_gambling_man from './img/a_gambling_man.jpg'
import before_i_go_to_sleep from './img/before_i_go_to_sleep.jpg'
import  blue_bird from './img/blue_bird.jpg'
import case_histories from './img/case_histories.jpg'
import dark_places from './img/dark_places.jpg'
import dead_simple from './img/dead_simple.jpg'
import gone_girl from './img/gone_girl.jpg'
import ill_we_be_gone_in_the_dark from './img/ill_we_be_gone_in_the_dark.jpg'
import in_cold_blood from './img/in_cold_blood.jpg'
import in_the_woods from './img/in_the_woods.jpg'
import my_sister_the_serial_killer from './img/my_sister_the_serial_killer.jpg'
import picture_you_dead from './img/picture_you_dead.jpg'
import presumed_innocent from './img/presumed_innocent.jpg'
import red_dragon from './img/red_dragon.jpg'
import the_alienist from './img/the_alienist.jpg'
import the_bat from './img/the_bat.jpg'
import the_bigsleep from './img/the_bigsleep.jpg'
import the_daughter_of_time from './img/the_daughter_of_time.jpg'
import the_girl_on_the_train from './img/the_girl_on_the_train.jpg'
import the_girl_with_the_dragon_tattoo from './img/the_girl_with_the_dragon_tattoo.jpg'
import the_long_drop from './img/the_long_drop.jpg'
import the_maltese_falcon from './img/the_maltese_falcon.jpg'
import the_silent_patient from './img/the_silent_patient.jpg'
import the_snowman from './img/the_snowman.jpg'


export const CBookItems = [
  {
    id:801,
    title:"A Gambling Man",
    image: a_gambling_man,
    price:699,
    
  },
  {
    id:802,
    title:"Before I Go To Sleep",
    image: before_i_go_to_sleep,
    price:299,
    
  },
  {
    id:803,
    title:"Blue Bird, Blue Bird",
    image: blue_bird,
    price:2999,
    
  },
  {
    id:804,
    title:"Case Histories",
    image: case_histories,
    price:199,
    
  },
  {
    id:805,
    title:"Dark Places",
    image: dark_places,
    price:399,
    
  },
  {
    id:806,
    title:"Dead Simple",
    image: dead_simple,
    price:199,
    
  },
  {
    id:807,
    title:"Gone Girl",
    image: gone_girl,
    price:199,
    
  },
  {
    id:808,
    title:"I'll Be Gone In The Dark",
    image: ill_we_be_gone_in_the_dark,
    price:1929,
    
  },
  {
    id:809,
    title:"In Cold Blood",
    image: in_cold_blood,
    price:799,
    
  },
  {
    id:810,
    title:"In The Woods",
    image: in_the_woods,
    price:799,
    
  },
  {
    id:811,
    title:"My Sister, the Serial Killer",
    image: my_sister_the_serial_killer,
    price:3849,
    
  },
  {
    id:812,
    title:"Picture You Dead",
    image: picture_you_dead,
    price:1799,
    
  },
  {
    id:813,
    price:499,
    title: "Presumed Innocent",
    image: presumed_innocent,
    
  },
  {
    id:814,
    price:199,
    title: "Red Dragon",
    image: red_dragon,
   
  },
  {id:815,
    price:799,
    title: "The Alienist",
    image: the_alienist,
    
  },
  {
    id:816,
    price:699,
    title: "The Bat",
    image: the_bat,
    
  },
  {
    id:817,
    price:799,
    title: "The Big Sleep",
    image: the_bigsleep,
    
  },
  {
    id:818,
    price:1329,
    title: "The Daughter of Time",
    image: the_daughter_of_time,
    
  },
  {
    id:819,
    price:299,
    title: "The Girl On The Train",
    image: the_girl_on_the_train,
    
  },
  {
    id:820,
    price:399,
    title: "The Girl with the Dragon Tattoo",
    image: the_girl_with_the_dragon_tattoo,
    
  },
  {
    id:821,
    price:999,
    title: "The Long Drop",
    image: the_long_drop,
    
  },
  {
    id:822,
    price:499,
    title: "The Maltese Falcon",
    image:the_maltese_falcon,    
  },
  {
    id:823,
    price:299,
    title: "The Silent Patient",
    image: the_silent_patient,
    
  },
  {
    id:824,
    price:799,
    title: "The Snowman",
    image: the_snowman,
    
  },
  
];